import React from "react";

import Section from "../components/Section";

import { CLIENT_SAMPLES } from "./../layouts/colors";

import { graphql } from "gatsby";

import { GatsbyImage, getImage } from "gatsby-plugin-image";
//import SampleSelector from "../components/SampleSelector";

import Box from "@mui/material/Box";
import { MenuItem } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import ExpandMoreIcon from "../images/expandIcon.svg";
import SampleContainer from "../components/SampleContainer";
import Sample from "../components/Sample";
import sampleData from "../../samples.json";

const sampleAudioDirectory = "music/";

const Clients = ({ data }) => {
  const SampleSelector = () => {
    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`full-width-tabpanel-${index}`}
          aria-labelledby={`full-width-tab-${index}`}
          {...other}
        >
          {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
      );
    }

    function getFileName(title) {
      return title.toLowerCase().replace(/ /g, "_");
    }

    const iconComponent = (props) => {
      return (
        <ExpandMoreIcon
          style={{ marginTop: "-15px" }}
          className={props.className + " "}
        />
      );
    };

    const sections = Object.keys(sampleData);

    const [playlist, setPlaylist] = React.useState(0);

    const handleChange = (event) => {
      setPlaylist(event.target.value);
    };

    return (
      <Box style={{ marginTop: "10px" }}>
        <FormControl fullWidth hiddenLabel={true}>
          <InputLabel id="demo-simple-select-label"></InputLabel>
          <Select
            MenuProps={{
              disableScrollLockX: true,
            }}
            IconComponent={iconComponent}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={playlist}
            label=""
            onChange={handleChange}
            sx={{
              color: "white", //"white",
              alignContent: "center",
              backgroundColor: "rgba(148, 148, 148, 0.368627451)", // "white", //"#282828",
              borderRadius: "12px",
              borderStyle: "none",
              boxShadow: "none",

              ".MuiOutlinedInput-notchedOutline": { border: 0 },

              border: "2px solid",
              borderColor: " rgba(255, 255, 255, 0)",
              transition: "all 250ms ease",
              "&:hover": {
                borderColor: "#ffffffff",
              },
              "&:focus-visible": {
                borderColor: "white",
                transition: "all 250ms ease",
              },

              " .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
              },

              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderRadius: "12px",
                borderColor: "white",
                margin: "-2px",
              },
            }}
          >
            {sections.map((section, index) => {
              return <MenuItem value={index}>{section}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <div style={{ height: "20px" }}></div>

        <div>
          {sections.map((section, index) => {
            return (
              <TabPanel value={playlist} index={index}>
                <SampleContainer>
                  {sampleData[section].map((song) => {
                    let sampleFileName = getFileName(song.title);
                    return (
                      <Sample
                        fileName={
                          sampleAudioDirectory + sampleFileName + ".mp3"
                        }
                        trackName={song.title}
                        albumName={song.album}
                        artistName={song.artist}
                        color="rgb(33, 11, 50)"
                      >
                        <GatsbyImage
                          style={{
                            height: "100%",
                            width: "100%",
                          }}
                          alt={song.album}
                          objectFit="cover"
                          image={getImage(getSampleImage(sampleFileName).node)}
                        ></GatsbyImage>
                      </Sample>
                    );
                  })}
                </SampleContainer>
              </TabPanel>
            );
          })}
        </div>
      </Box>
    );
  };

  function getSampleImage(name) {
    return data.allFile.edges.find(
      (item) =>
        item.node.childImageSharp.fluid.src.split("/").pop().split(".")[0] ===
        name
    );
  }

  // const im = data.allFile.edges[0];
  return (
    <div style={{ overflowX: "hidden" }}>
      <Section
        tabColor={CLIENT_SAMPLES.tab}
        bodyColor={CLIENT_SAMPLES.body}
        hideHeaderMobile={true}
        title="Client Samples"
        caption="Hear samples from artists recorded & mixed at Lange Studios"
      >
        {/* <div key="t">
          <GatsbyImage
            style={{ width: "100%", height: "100%" }}
            image={getImage(getSampleImage("maya").node)}
          ></GatsbyImage>
        </div> */}
        {/* 
        {data.allFile.edges.map((img) => (
          <GatsbyImage
            imgtyle={{ aspectRatio: "1 / 1" }}
            // fluid={img.node.childImageSharp.fluid}
            image={getImage(img.node)}
          />
        ))} */}

        <div className="link-parent">
          <a
            rel="noreferrer"
            href="https://open.spotify.com/user/31bzul4uimrdoczmaxmh43h4h3vi"
            className="icon-link link-spotify"
          >
            <svg
              className="social-media-icon spotify-icon2"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ minWidth: "48px", minHeight: "48px" }}
            >
              <path
                fill="currentColor"
                d="M17.9 10.9C14.7 9 9.35 8.8 6.3 9.75c-.5.15-1-.15-1.15-.6c-.15-.5.15-1 .6-1.15c3.55-1.05 9.4-.85 13.1 1.35c.45.25.6.85.35 1.3c-.25.35-.85.5-1.3.25m-.1 2.8c-.25.35-.7.5-1.05.25c-2.7-1.65-6.8-2.15-9.95-1.15c-.4.1-.85-.1-.95-.5c-.1-.4.1-.85.5-.95c3.65-1.1 8.15-.55 11.25 1.35c.3.15.45.65.2 1m-1.2 2.75c-.2.3-.55.4-.85.2c-2.35-1.45-5.3-1.75-8.8-.95c-.35.1-.65-.15-.75-.45c-.1-.35.15-.65.45-.75c3.8-.85 7.1-.5 9.7 1.1c.35.15.4.55.25.85M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"
              />
            </svg>
            <div>Visit our Spotify profile to hear more from our clients</div>
          </a>
        </div>
        <div
          className="h3-wrapper"
          style={{
            width: "100%",
            marginBottom: "0px",
            marginTop: "10px",
            maxWidth: "600px",
          }}
        >
          <div className="bio-rectangle-parent">
            <div className="bio-rectangle"></div>
            <div className="bio-rectangle-two"></div>
          </div>
          <h3
            style={{
              padding: "0px",
            }}
          >
            Select a genre from the dropdown menu below to view its samples
          </h3>
        </div>

        <SampleSelector></SampleSelector>
        {/* <div style={{ paddingTop: "5px" }}>{<SoundCloudDesktop />}</div> */}
        <div className="link-parent" id="bottom-link-parent">
          <a
            rel="noreferrer"
            href="https://open.spotify.com/user/31bzul4uimrdoczmaxmh43h4h3vi"
            className="icon-link link-spotify"
          >
            <svg
              className="social-media-icon spotify-icon2"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ minWidth: "48px", minHeight: "48px" }}
            >
              <path
                fill="currentColor"
                d="M17.9 10.9C14.7 9 9.35 8.8 6.3 9.75c-.5.15-1-.15-1.15-.6c-.15-.5.15-1 .6-1.15c3.55-1.05 9.4-.85 13.1 1.35c.45.25.6.85.35 1.3c-.25.35-.85.5-1.3.25m-.1 2.8c-.25.35-.7.5-1.05.25c-2.7-1.65-6.8-2.15-9.95-1.15c-.4.1-.85-.1-.95-.5c-.1-.4.1-.85.5-.95c3.65-1.1 8.15-.55 11.25 1.35c.3.15.45.65.2 1m-1.2 2.75c-.2.3-.55.4-.85.2c-2.35-1.45-5.3-1.75-8.8-.95c-.35.1-.65-.15-.75-.45c-.1-.35.15-.65.45-.75c3.8-.85 7.1-.5 9.7 1.1c.35.15.4.55.25.85M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2Z"
              />
            </svg>
            <div>Visit our Spotify profile to hear more from our clients</div>
          </a>
        </div>
      </Section>
    </div>
  );
};

export default Clients;
export const Head = () => (
  <>
    <html lang="en" />
    <meta name="author" content="Justin Haddock" />
    <meta name="copyright" content="Lange Studios" />

    <meta name="title" content="Client Samples" />
    <meta name="theme-color" content={CLIENT_SAMPLES.mobile} />
    <title>Client Samples | Lange Studios</title>

    <meta
      name="keywords"
      content="Lange Studios, Recording Studio, client samples, samples. clients, client, spotify, Spotify, tracks, songs, Americana, Jazz, Singer-Songwriter, featured, Latin, Classical"
    />
    <meta
      name="description"
      content="Listen to samples from our artists. Jazz, Americana, Latin, Classical, and Singer-Songwriter tracks recorded & mixed at Lange Studios"
    ></meta>
  </>
);

export const query = graphql`
  query HomePageQuery {
    allFile(
      filter: {
        extension: { regex: "/(jpg)|(jpeg)|(png)/" }
        relativeDirectory: { eq: "sample" }
      }
    ) {
      edges {
        node {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
            fluid {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
